import type { LineItem } from '~/types/models/commercetools/LineItem.model';

interface ProductGiftInfo {
  id: string;
  amount: number;
  requiresCode: boolean;
  key: string | null;
  isProductDiscount?: boolean;
  name: string | null;
}

const checkIfProductIsGift = (product: LineItem): ProductGiftInfo | null => {
  let productGiftInfo = null;

  const productAmount = product.price?.discounted?.value?.centAmount || product.price.value.centAmount;

  // If product is GIFT via line item discount (100% in total discount)
  if (product.price.discounted && product.price.discounted.value.centAmount === 0) {
    productGiftInfo = {
      id: 'GIFT_' + product.id,
      amount: productAmount ? productAmount * product.quantity : 0,
      requiresCode: false,
      key: '',
      isProductDiscount: true,
      name: product.price?.discounted?.discount?.name,
    };
  } else {
    // If product is GIFT via cart discount (both with/without discount promo code)
    product?.discountedPricePerQuantity?.forEach((discountedPrice) => {
      discountedPrice?.discountedPrice?.includedDiscounts?.forEach((includedDiscounts) => {
        if (
          includedDiscounts?.discountedAmount?.centAmount === product.price.value.centAmount ||
          includedDiscounts?.discountedAmount?.centAmount === product.price?.discounted?.value?.centAmount
        ) {
          productGiftInfo = {
            id: includedDiscounts.discount?.id,
            amount: productAmount ? productAmount * product.quantity : 0,
            requiresCode: includedDiscounts.discount?.requiresDiscountCode,
            key: includedDiscounts.discount?.key,
            name: includedDiscounts.discount?.name,
          };
        }
      });
    });
  }

  return productGiftInfo;
};

export { checkIfProductIsGift };
